import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { lenis } from './lenis'
import htmx from 'htmx.org'

gsap.registerPlugin(ScrollTrigger)

export const initSprig = () => {
 
	let el = document.querySelector('[data-sprig-container]')
	let entries = document.querySelector('[data-sprig-entries]')

	if (!el || !entries) return

	htmx.on('htmx:beforeRequest', (e) => {
		el = document.querySelector('[data-sprig-container]')
		entries = document.querySelector('[data-sprig-entries]')

		gsap.to(entries, {
			duration: 0.35,
			opacity: 0,
			onComplete: () => {
			}
		})

		lenis.scrollTo(entries, {
			duration: 1.5,
			offset: -200
		})
	})

	htmx.on('htmx:afterSwap', () => {
		el = document.querySelector('[data-sprig-container]')
		entries = document.querySelector('[data-sprig-entries]')

		const animTrigger = el.querySelector('[data-anim-trigger]')

		animTrigger.dataset.animTrigger = 'ready'

		gsap.fromTo(entries, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.35
		})
	})
}

export default () => {}